@if (selectedTab) {
  <div class="bar-backdrop position-fixed top-0 bottom-0 start-0 end-0"
    (click)="selectedTab = undefined"
    >
  </div>
}

<div class="bar-spacer"></div>

<div class="bar-container d-flex-row">
  <div class="bar-tabs d-flex-column h-100 align-items-stretch">
    @for ($tab of tabs; track $tab) {
      @if (!$tab.webOnly || platform.isWeb) {
        <button
          [ngClass]="$tab.classes"
          [title]="$tab.name | titlecase"
          [class.selected]="selectedTab === $tab.name"
          (click)="tabClicked($tab)"
          >
          @if ($tab.icon) {
            <i [class]="tabIcon($tab)"></i>
          }
          @if ($tab.image) {
            <img [src]="$tab.image" [alt]="$tab.name">
          }
        </button>
      }
    }
  </div>

  <div class="bar-panel flex-fill d-flex flex-column flex-nowrap mh-100 h-100">
    @switch (selectedTab) {
      @case ('settings') {
        <app-match-editor class="bar-form flex-fill" />
      }
      @case ('guesses') {
        <app-guess-editor class="bar-form flex-fill" />
      }
      @case ('themes') {
        <app-theme-slide-editor class="bar-form flex-fill" />
      }
      @case ('optional') {
        <app-optional-team-editor class="bar-form flex-fill" />
      }
    }
  </div>
</div>
